<h3 mat-dialog-title>Delete {{data.account.friendlyName}}?</h3>

<mat-dialog-content>
    <ng-container *ngIf="!isUserAccount && data.account.hasOwnProperty('depositBankAccount')">
        <p>This bank account is a deposit account.</p>
        <p>
            It is capable of being a deposit destination for funds your users pay for charges.
            You must select a different deposit account to replace this account
            for funds from any such items.
        </p>

        <div class="form-group">
            <label>
                New Bank Account:
            </label>

            <select [(ngModel)]="replacementDepositAccount"
                    class="form-control  form-control-sm">
                <!--suppress HtmlUnknownAttribute -->
                <ng-template [ngForOf]="data.replacementCandidates"
                             let-bank
                             ngFor>
                    <option [innerHTML]="bank.friendlyName"
                            [ngValue]="bank"></option>
                </ng-template>
            </select>
        </div>
    </ng-container>

    <ng-container *ngIf="!isUserAccount && data.account.hasOwnProperty('linkedBankAccount')" class="pt-4">
        <p>This bank account is a linked account.</p>
        <p>By deleting this account you will no longer be able to import transaction data from this bank account.</p>
    </ng-container>

    <p [class.pb-4]="!isUserAccount && data.account.hasOwnProperty('linkedBankAccount') && !data.account.hasOwnProperty('depositBankAccount')">
        Are you sure you want to remove the selected bank account?</p>
    <p *ngIf="isUserAccount">
        Payments that have already been submitted will not be cancelled.
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        No, Keep Bank Account
    </button>
    <button (click)="deleteAccount()"
            [disabled]="data.account.hasOwnProperty('depositBankAccount') && !replacementDepositAccount || deleteInFlight"
            class="btn btn-primary">
        Yes, Remove
    </button>
</mat-dialog-actions>
